// Copyright (c) 2026 Dyna Robotics, Inc. All rights reserved.
// Dyna Robotics Proprietary and Confidential.
// Unauthorized copying, use, or distribution is prohibited.
// SPDX-License-Identifier: LicenseRef-Dyna-Internal

/**
 * Field rules the server enforces, restated for the browser (design doc §7.3, §8.3).
 *
 * These are ports, not second opinions, in the same sense as `scanner/serials.ts`, and
 * `constraints.parity.test.ts` reads the Python source to fail if they drift. The server
 * validates regardless; these exist so a form can say what it wants *before* the round
 * trip, instead of answering a rejected submission with `string_pattern_mismatch`.
 */

/**
 * 2–8 upper-case alphanumerics starting with a letter.
 *
 * Narrow on purpose: this prefix is the leading segment of every archive number the product
 * type will ever mint (§7.4.1), and it cannot be changed afterwards — the type is immutable
 * once created (US-P-05). It is the one field on that form where a typo is permanent.
 */
export const ARCHIVE_PREFIX_PATTERN = /^[A-Z][A-Z0-9]{1,7}$/;

/** The source-of-truth string, kept separate so an `<input pattern>` can use it verbatim. */
export const ARCHIVE_PREFIX_PATTERN_SOURCE = "[A-Z][A-Z0-9]{1,7}";

/** A device-number rule is run against every number submitted for the type; §8.3 bounds it. */
export const DEVICE_NO_REGEX_MAX_LEN = 200;

export const NAME_MAX_LEN = 255;
